import React, { useState } from 'react';
import axios from "axios";

import SvgIcon from "../../SharedComponents/Icons";
import NotificationPopup from "../../SharedComponents/NotificationPopup";
import CompanyForm from "./CompanyForm";
import ContactInfoForm from "./ContactInfoForm";

import './index.sass';


const SignupForm = ({ accountType, paymentType }) => {

  const [currentStep, setCurrentStep] = useState(1);
  const [contactValues, setContactValues] = useState({});
  const [companyValues, setCompanyValues] = useState({});
  const [validationTrigger, setValidationTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const [contactSubmitErrors, setContactSubmitErrors] = useState(null);
  const [companySubmitErrors, setCompanySubmitErrors] = useState(null);
  const [requestError, setRequestError] = useState(null);


  const submitCompanyForm = (values, step) => {
    if (values) {
      setCompanyValues(values);
      if (validationTrigger) {
        setValidationTrigger(false);
        setCurrentStep(1);
      } else {
        createProvider(values);
      }
    };

    step && setValidationTrigger(true);
  };


  const submitContactForm = (values) => {
    if (values) {
      const { fifth_element, contact_person, email, name, phone } = values;
      const params = { provider_unfinished: { contact_person, email, name, phone: phone.replace(/\D/g, "") } };
      const url = '/api/frontend/signup/first_step';

      setContactValues(values);
      setLoading(true);

      !fifth_element && axios
        .post(url, params, { headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }})
        .then(response => {
          setLoading(false);
          response.data.status === 'created' && setCurrentStep(2);
        })
        .catch(error => {
          const errors = error.response && error.response.data && error.response.data.errors;

          setLoading(false);

          (errors && Object.keys(errors).length)
            ? setContactSubmitErrors(errors)
            : setRequestError(true);

          console.log('Error: ', error);
        });
    }
  };

  const createProvider = (values) => {
    const { contact_person, email, name, phone, sms_order_notification } = contactValues;
    const { address_line_1, cvr, fifth_element, invoice_email, password, password_confirmation, postal_code, postal_name, terms_of_service } = values;
    const url = '/api/frontend/signup';
    const params = {
      provider: {
        account_type: accountType,
        address_line_1,
        contact_person,
        cvr,
        email,
        invoice_email,
        name,
        password,
        password_confirmation,
        payment_interval: paymentType,
        phone: phone.replace(/\D/g, ""),
        postal_code,
        postal_name,
        sms_order_notification,
        terms_of_service
      }};

    setLoading(true);

    !fifth_element && axios
      .post(url, params, { headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }})
      .then(response => {
        const { status, redirect_path } = response.data;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'ga4-signup-form-submit',
          eventCategory: 'signup-form-submit',
          eventAction: 'signup-form-submit',
        });

        setLoading(false);
        status === 'created' && redirect_path && (window.location.href = redirect_path);
      })
      .catch(error => {
        const errors = error.response && error.response.data && error.response.data.errors;

        setLoading(false);

        (errors && Object.keys(errors).length)
          ? setCompanySubmitErrors(errors)
          : setRequestError(true);

        console.log('Error: ', error);
      });
  };


  return (
    <div className="signup-form">

      <NotificationPopup
        customClass={'error'}
        handleClose={() => setRequestError(false)}
        message={'Noget gik galt. Prøv venligst senere eller kontakt os hvis fejlen opstår igen.'}
        visible={requestError} />

      <div className="signup-form__headline-wrapper">
        <div className="signup-form__header">
          { currentStep === 1
            ? 'Din virksomhed'
            : 'Dine kontaktoplysninger'
          }
        </div>

        <div className="signup-form__step-info">
          Step { currentStep } / 2
        </div>

        <div className="signup-form__step-info-underline filled left" />
        <div className={`signup-form__step-info-underline right ${currentStep === 2 ? 'filled' : ''}`} />
      </div>

      <div className={`signup-form__form-wrapper ${currentStep === 2 ? 'with-button' : ''}`}>

        { currentStep === 2 &&
          <div className={`signup-form__back-button ${loading ? 'inactive' : ''}`}
               onClick={() => submitCompanyForm(null, 1)}>
            <SvgIcon name="arrow_back" size={24} />
            Tilbage
          </div>
        }

        { currentStep === 1
          ?
          <ContactInfoForm
            currentValues={contactValues}
            loading={loading}
            setSubmitErrors={setContactSubmitErrors}
            submitErrors={contactSubmitErrors}
            submitHandler={submitContactForm}
          />
          :
          <CompanyForm
            accountType={accountType}
            currentValues={companyValues}
            loading={loading}
            paymentType={paymentType}
            setSubmitErrors={setCompanySubmitErrors}
            setValidationTrigger={setValidationTrigger}
            submitErrors={companySubmitErrors}
            submitHandler={submitCompanyForm}
            validationTrigger={validationTrigger}
            goBack={() => {
              setCurrentStep(1);
              setValidationTrigger(false);
            }}
          />
        }

      </div>
    </div>
  )
}

export default SignupForm;
